var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoWhiteDarkModeFalse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 32,
    viewBox: "0 0 95 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#logo-white-dark-mode-false_svg__paint0_linear_9917_3316)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.714 16C5.714 10.32 10.319 5.714 16 5.714c1.403 0 2.77.282 4.035.822a1.662 1.662 0 01-1.302 3.057A6.943 6.943 0 0016 9.037 6.966 6.966 0 009.032 16 6.966 6.966 0 0016 22.963 6.965 6.965 0 0022.967 16a1.66 1.66 0 113.318 0c0 5.681-4.605 10.286-10.285 10.286S5.714 21.68 5.714 16zm15.762-4.71a1.752 1.752 0 011.577-1.747l.18-.01c.485 0 .924.197 1.242.515.318.318.515.757.515 1.242s-.197.924-.515 1.242a1.751 1.751 0 01-1.242.514c-.485 0-.925-.196-1.243-.514a1.751 1.751 0 01-.514-1.242z",
    fill: "url(#logo-white-dark-mode-false_svg__paint1_linear_9917_3316)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.013 23.922c2.237 0 4.136-.766 5.695-2.297 1.56-1.545 2.34-3.433 2.34-5.664 0-2.23-.78-4.115-2.34-5.654C54.148 8.77 52.25 8 50.013 8s-4.131.77-5.684 2.307C42.776 11.846 42 13.73 42 15.961c0 2.23.776 4.115 2.329 5.653 1.553 1.539 3.447 2.308 5.684 2.308zm0-2.953c-1.413 0-2.597-.466-3.554-1.4-.957-.947-1.435-2.15-1.435-3.608 0-1.458.478-2.661 1.435-3.609.957-.947 2.141-1.421 3.554-1.421 1.413 0 2.598.474 3.554 1.421.957.948 1.435 2.15 1.435 3.609 0 1.458-.478 2.657-1.435 3.598-.956.94-2.141 1.41-3.554 1.41zm12.268 2.1c.802.583 2.182.765 4.139.547v-2.56c-.545.03-1 .034-1.369.012-.368-.022-.647-.12-.839-.296-.19-.174-.287-.451-.287-.83v-4.55h2.495V12.68h-2.495V9.618l-2.847.853v2.21h-1.92v2.711h1.92v4.55c0 1.501.4 2.544 1.203 3.127zm7.952 0c.802.583 2.182.765 4.139.547v-2.56c-.545.03-1 .034-1.369.012-.368-.022-.647-.12-.839-.296-.19-.174-.287-.451-.287-.83v-4.55h2.495V12.68h-2.495V9.618l-2.847.853v2.21h-1.92v2.711h1.92v4.55c0 1.501.4 2.544 1.203 3.127zm9.221.547v-5.227c0-1.05.342-1.801 1.027-2.253.684-.452 1.46-.627 2.329-.525v-3.15c-.751 0-1.432.176-2.042.525-.611.35-1.049.875-1.314 1.575v-1.88h-2.847v10.935h2.847zm5.7 4.374c1.413.073 2.594-.244 3.544-.952.949-.707 1.71-1.848 2.284-3.422L95 12.68h-3.046l-2.45 7.349-2.87-7.349H83.52l4.525 10.586c-.265.743-.621 1.283-1.07 1.618-.449.335-1.056.496-1.821.481v2.625z",
    fill: "#101828"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-white-dark-mode-false_svg__paint0_linear_9917_3316",
    x1: 8,
    y1: 32,
    x2: 24,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-white-dark-mode-false_svg__paint1_linear_9917_3316",
    x1: 16,
    y1: 5.714,
    x2: 16,
    y2: 26.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })))));
}

export default SvgLogoWhiteDarkModeFalse;